var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61583 3.375L7.125 3.88417L2.20667 8.79167H1.70833V8.29333L6.61583 3.375ZM8.56583 0.125C8.43042 0.125 8.28958 0.179167 8.18667 0.282083L7.19542 1.27333L9.22667 3.30458L10.2179 2.31333C10.4292 2.10208 10.4292 1.75 10.2179 1.54958L8.95042 0.282083C8.84208 0.17375 8.70667 0.125 8.56583 0.125ZM6.61583 1.85292L0.625 7.84375V9.875H2.65625L8.64708 3.88417L6.61583 1.85292Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.70cb3311.svg";
export { ForwardRef as ReactComponent };